import React, {Component} from 'react';
import OcenyKierowcowTable from "./OcenyKierowcowTable";


export default class OcenyKierowcowTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {

        return (
            <div>
                <OcenyKierowcowTable data={this.props.ocenyKierowcow}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/oceny/components/OcenyKierowcowTab.js